import AverageScoreImage from "./AverageScoreImage";
import styles from "./AverageUserScore.module.css";

type AverageUSerScoreProps = {
  score: number;
};

export default function AverageUserScore(props: AverageUSerScoreProps) {
  return (
    <div className={styles.parent}>
      <div className={styles.svgDiv}>
        <AverageScoreImage />
      </div>
      <div className={styles.scoreDiv}>
        <div className={styles.scoreText}>
          <p>Average user score</p>
          <p className={styles.score}>{(props.score * 100).toFixed(0)}</p>
        </div>
        <div className={styles.barContainer}>
          <div className={styles.barBackground}></div>
          <div
            className={styles.barScore}
            style={{ width: `${(props.score * 100).toFixed(0)}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
}
